<!-- 原材料达交率报表 -->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          v-decorator="['organizationCode', { rules: [{ required: true }] }]"
          :allow-clear="false"
          :default-active-first-option="true"
          slot="organizationCode"
          :value.sync="queryParams.organizationCode"
          :dropdown-match-select-width="false"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <!-- <global-select
          slot="organizationCode"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.organizationCode"
          selectType="selectAssemble"
          :selectData="selectInventOrgList"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
          :allowClear="false"
        /> -->
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiInvCallRequestLinesNewExport" ref="download" />
        <a-button type="primary" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.RAW_MATERIAL_DELIVERY_RATE_LIST, // 表格方案配置唯一值
              }"
        >
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiInvGetRawMaterialDeliveryRateReport, apiInvCallRequestLinesNewExport } from '@/api/report/raw-material-delivery-rate'
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'Raw-material-delivery-rate', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode,
			inventOrg: (state) => state.user.inventOrg
    })
  },
  data() {
    return {
      apiInvCallRequestLinesNewExport,
      // selectInventOrgList: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiInvGetRawMaterialDeliveryRateReport, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
				organizationCode: null,
				staDemandDate: null,
				endDemandDate: null
      },
      // 表格数据
      tableList: [],
      formList: [
        {
          label: '叫料组织',
					decorator: ['organizationCode'],
					type: 'organizationCode'
        },
        {
          label: '要求到货时间',
          type: 'range',
          decorator: ['demandDate', { rules: [{ required: true }] }],
          disposeFormat: {
            staDemandDate: (change) => {
              return change[0].format('YYYY-MM-DD 00:00:00')
            },
            endDemandDate: (change) => {
              return change[1].format('YYYY-MM-DD 23:59:59')
            }
          }
        }
      ],
      // 表格字段
      columns: [
        {
          title: '叫料组织',
          dataIndex: 'organizationName',
          align: 'center',
          ellipsis: true
        },
				{
          title: '叫料行数',
          dataIndex: 'lineNum',
          align: 'center',
          ellipsis: true
        },
        {
          title: '达交叫料行数',
          dataIndex: 'reachLineNum',
          align: 'center',
          ellipsis: true
        },
				{
          title: '延期叫料行数',
          dataIndex: 'extensionLineNum',
          align: 'center',
          ellipsis: true
        },
				{
          title: '达交率',
          dataIndex: 'orderFillRate',
          align: 'center',
          ellipsis: true
        }
      ]
    }
  },
  created() {},
  mounted() {
    // this.onSearch()
    // this.selectInventOrgList = this.inventOrg.map(item => {
    //   return {
    //     ...item,
    //     label: item.label.replace('库存组织', '')
    //   }
    // })
    if (!this.queryParams?.organizationCode) {
      this.queryParams.organizationCode = this.organizationCodeOrigin
    }
  },
  methods: {
    // 表单搜索
    onSearch(value = {}) {
      const params = {
        ...this.queryParams,
        ...value
      }
      if (!params.staDemandDate || !params.endDemandDate) {
        this.$message.warning('请选择要求到货时间')
        return;
      }
      delete params.searchFormLabel;
      this.$refs.dataTable.searchParams = params
      this.$refs.dataTable.getData()
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
				organizationCode: null,
				staDemandDate: null,
				endDemandDate: null
      }
    },
    // 搜索框展开、收起
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
      // this.download(
      //   'inv/invCallRequestLines/exportRawMaterialReport',
      //   this.$refs.dataTable.searchParams,
      //   `原材料达交率报表_${new Date().getTime()}.xlsx`
      // )
    }
  }
}
</script>

<style scoped lang="less"></style>
